const getters = {
	ready (state, getters) {
		return state.users
	}
}

export default getters
